import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-maroon-600 text-cream-50 hover:bg-maroon-700",
        secondary: "border-transparent bg-cream-100 text-maroon-700 hover:bg-cream-200",
        destructive: "border-transparent bg-red-500 text-cream-50 hover:bg-red-600",
        success: "border-transparent bg-green-700 text-cream-50 hover:bg-green-800",
        warning: "border-transparent bg-amber-100 text-amber-800 hover:bg-amber-200",
        outline: "text-ink border-cream-200",
        muted: "border-transparent bg-cream-200 text-muted",
      },
    },
    defaultVariants: { variant: "default" },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
